import { render, staticRenderFns } from "./printdeathcertificate.vue?vue&type=template&id=efda44da&"
import script from "./printdeathcertificate.vue?vue&type=script&lang=js&"
export * from "./printdeathcertificate.vue?vue&type=script&lang=js&"
import style0 from "./printdeathcertificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports